import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { InputBoxComponent } from './input-box.component';
import { PopoverModule } from '../popover/popover.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [InputBoxComponent],
  imports: [CommonModule, FormsModule, MaterialsModule, PopoverModule, TranslateModule],
  exports: [InputBoxComponent],
})
export class InputBoxModule {}
